import { DraggableItem, DraggableItemNumber } from "../../pages/service/pages/catalog/pages/form/components/catalogOption/components/draggableItem/types";
import { DropDownLink } from "../../pages/service/pages/catalog/pages/form/types";


const generateId = (): number => {
    //const timestamp = Date.now();
    //const random = Math.floor(Math.random() * 10000);
    const random = Date.now() + Math.floor(Math.random() * 1000);
    return random;
};

const normalizeIds = (items: DraggableItem[]): DraggableItemNumber[] => {
    let counter = 1;

    const processNode = (node: DraggableItem): DraggableItemNumber => {

        const regex = /^[0-9]*$/;
        const onlyNumbers = regex.test(node.id);

        const newId = onlyNumbers && (node.level==1 || node.level==2) ? Number(node.id) : counter /* onlyNumbers ? Number(node.id) : generateId() */;
        counter++;

        return {
            ...node,
            id: newId,
            children: node.children?.map(processNode) ?? [],
        };
    };

    return items.map(processNode);
};

const formatDropDownLinks = (node: DraggableItemNumber, parent?: DraggableItemNumber): DropDownLink[] => {
    let links: DropDownLink[] = [];

    node.children.forEach((child, i) => {
        const parentEditable = parent?.isEditable ?? false;
        const currentEditable = node.isEditable;
        const childEditable = child.isEditable;

        const link: DropDownLink = {
            parent_drop_down_id: null,
            parent_drop_down: undefined,
            current_drop_down_id: null,
            current_drop_down: undefined,
            next_drop_down_id: null,
            next_drop_down: undefined,
            current_node: node.id,
            next_node: child.id,
            required_text: node.textInput ?? false,
        };

        // === CASOS SEGÚN COMBINACIONES ===
        // Caso 1: Padre texto / Item texto / Hijo texto
        if (parentEditable && currentEditable && childEditable) {
            link.parent_drop_down_id = null;
            link.parent_drop_down = parent?.label;
            link.current_drop_down_id = null;
            link.current_drop_down = node.label;
            link.next_drop_down_id = null;
            link.next_drop_down = child.label;
        }

        // Caso 2: Padre texto / Item texto / Hijo catálogo
        else if (parentEditable && currentEditable && !childEditable) {
            link.parent_drop_down_id = null;
            link.parent_drop_down = parent?.label;
            link.current_drop_down_id = null;
            link.current_drop_down = node.label;
            link.next_drop_down_id = child.itemSubCatalogId ?? null;
            link.next_drop_down = undefined;
        }

        // Caso 3: Padre texto / Item catálogo / Hijo catálogo
        else if (parentEditable && !currentEditable && !childEditable) {
            link.parent_drop_down_id = null;
            link.parent_drop_down = parent?.label;
            link.current_drop_down_id = node.itemSubCatalogId ?? null;
            link.current_drop_down = undefined;
            link.next_drop_down_id = child.itemSubCatalogId ?? null;
            link.next_drop_down = undefined;
        }

        // Caso 4: Padre catálogo / Item catálogo / Hijo catálogo
        else if (!parentEditable && !currentEditable && !childEditable) {
            link.parent_drop_down_id = parent?.itemSubCatalogId ?? null;
            link.parent_drop_down = undefined;
            link.current_drop_down_id = node.itemSubCatalogId ?? null;
            link.current_drop_down = undefined;
            link.next_drop_down_id = child.itemSubCatalogId ?? null;
            link.next_drop_down = undefined;
        }

        // Caso 5: Padre catálogo / Item texto / Hijo texto
        else if (!parentEditable && currentEditable && childEditable) {
            link.parent_drop_down_id = parent?.itemSubCatalogId ?? null;
            link.parent_drop_down = undefined;
            link.current_drop_down_id = null;
            link.current_drop_down = node.label;
            link.next_drop_down_id = null;
            link.next_drop_down = child.label;
        }

        // Caso 6: Padre catálogo / Item catálogo / Hijo texto
        else if (!parentEditable && !currentEditable && childEditable) {
            link.parent_drop_down_id = parent?.itemSubCatalogId ?? null;
            link.parent_drop_down = undefined;
            link.current_drop_down_id = node.itemSubCatalogId ?? null;
            link.current_drop_down = undefined;
            link.next_drop_down_id = null;
            link.next_drop_down = child.label;
        }

        // Caso 7: Padre texto / Item catálogo / Hijo texto
        else if (parentEditable && !currentEditable && childEditable) {
            link.parent_drop_down_id = null;
            link.parent_drop_down = parent?.label ?? '';
            link.current_drop_down_id = node.itemSubCatalogId ?? null;
            link.current_drop_down = undefined;
            link.next_drop_down_id = null;
            link.next_drop_down = child.label;
        }

        // Caso 8: Padre catálogo / Item texto / Hijo catálogo
        else if (!parentEditable && currentEditable && !childEditable) {
            link.parent_drop_down_id = parent?.itemSubCatalogId ?? null;
            link.parent_drop_down = undefined;
            link.current_drop_down_id = null;
            link.current_drop_down = node.label;
            link.next_drop_down_id = child.itemSubCatalogId ?? null;
            link.next_drop_down = undefined;
        }

        //Si el nivel del nodo actual es 3, forzar parent_* a null
        if (node.level === 3) {
            link.parent_drop_down_id = null;
            link.parent_drop_down = undefined;
        }

        links.push(link);
        links = links.concat(formatDropDownLinks(child, node)); // recursión
    });

    // === CASO FINAL: NODO SIN HIJOS ===
    if (node.children.length === 0 && parent) {
        const parentEditable = parent?.isEditable ?? false;
        const currentEditable = node.isEditable;

        const link: DropDownLink = {
            parent_drop_down_id: null,
            parent_drop_down: undefined,
            current_drop_down_id: null,
            current_drop_down: undefined,
            next_drop_down_id: null,
            next_drop_down: undefined,
            current_node: node.id,
            next_node: null,
            required_text: node.textInput ?? false,
        };

        //Mismas reglas pero sin next_*
        if (parentEditable && currentEditable) {
            // Caso 1 sin hijo (texto / texto)
            link.parent_drop_down_id = null;
            link.parent_drop_down = parent.label;
            link.current_drop_down_id = null;
            link.current_drop_down = node.label;
        } else if (parentEditable && !currentEditable) {
            // Caso 3 o 7 (texto / catálogo)
            link.parent_drop_down_id = null;
            link.parent_drop_down = parent.label;
            link.current_drop_down_id = node.itemSubCatalogId ?? null;
            link.current_drop_down = undefined;
        } else if (!parentEditable && !currentEditable) {
            // Caso 4 o 6 (catálogo / catálogo)
            link.parent_drop_down_id = parent.itemSubCatalogId ?? null;
            link.parent_drop_down = undefined;
            link.current_drop_down_id = node.itemSubCatalogId ?? null;
            link.current_drop_down = undefined;
        } else if (!parentEditable && currentEditable) {
            // Caso 5 u 8 (catálogo / texto)
            link.parent_drop_down_id = parent.itemSubCatalogId ?? null;
            link.parent_drop_down = undefined;
            link.current_drop_down_id = null;
            link.current_drop_down = node.label;
        }

        //Regla para nivel 3
        if (node.level === 3) {
            link.parent_drop_down_id = null;
            link.parent_drop_down = undefined;
        }

        links.push(link);
    }

    return links;
};

const createCatalogBody = ({ catalogName, items }: { catalogName: string; items: DraggableItem[] }) => {

    const normalizedItems = normalizeIds(items);

    const categories = normalizedItems.map((category, index) => ({
        name: category.label,
        position: index,
        subcategories: category.children.map((subcategory, index) => ({
            name: subcategory.label,
            position: index,
            priorityId: subcategory.priority ?? null,
            requestText: subcategory.textInput ?? false,
            supplierId: subcategory.provider ?? null,
            ...(subcategory.children.length > 0 && {
                drop_downs_links: subcategory.children.flatMap(child => formatDropDownLinks(child, subcategory)),
            }),
        })),
    }));


    const body = {
        name: catalogName,
        categories,
    }

    return body
}

const updateCatalogBody = ({ catalogName, items, itemsFromEndpoint }: { catalogName: string; items: DraggableItem[]; itemsFromEndpoint: DraggableItem[]; }) => {

    const normalizedItems = normalizeIds(items);
    const normalizeditemsFromEndpoint = normalizeIds(itemsFromEndpoint);

    const deepCompareItems = (
        oldItem: DraggableItemNumber,
        newItem: DraggableItemNumber,
        newPosition?: number
    ): boolean => {
        if (
            oldItem.label !== newItem.label ||
            oldItem.priority !== newItem.priority ||
            oldItem.provider !== newItem.provider ||
            oldItem.textInput !== newItem.textInput ||
            oldItem.isEditable !== newItem.isEditable ||
            (newPosition !== undefined && oldItem.position !== newPosition)
        ) {
            return true;
        }

        if (oldItem.children.length !== newItem.children.length) return true;

        for (let i = 0; i < oldItem.children.length; i++) {
            const oldChild = oldItem.children[i];
            const newChild = newItem.children[i];
            if (!newChild || String(oldChild.id) !== String(newChild.id))
                return true;
            if (deepCompareItems(oldChild, newChild)) return true;
        }

        return false;
    };

    const newCategories: any[] = [];
    const editCategories: { id: number; name: string, position: number }[] = [];
    const categoriesToDelete: number[] = [];

    const newSubcategories: any[] = [];
    const editSubcategories: any[] = [];
    const subcategoriesToDelete: number[] = [];

    normalizedItems.forEach((cat, index) => {
        const oldCat = normalizeditemsFromEndpoint.find(
            (c) => c.id === cat.id
        );

        if (!oldCat) {
            newCategories.push({
                name: cat.label,
                position: index,
                subcategories: cat.children.map((sub, index) => ({
                    name: sub.label,
                    position: index,
                    priorityId: sub.priority ?? null,
                    requestText: sub.textInput ?? false,
                    supplierId: sub.provider ?? null,
                    ...(sub.children.length > 0 && {
                        drop_downs_links: sub.children.flatMap((ch) =>
                            formatDropDownLinks(ch, sub)
                        ),
                    }),
                })),
            });
            return;
        }

        if (oldCat && (oldCat.label !== cat.label || oldCat.position !== index)) {
            editCategories.push({ id: oldCat.id, name: cat.label, position: index });
        }

        const oldSubs = oldCat?.children || [];
        const newSubs = cat.children;

        newSubs.forEach((sub, index) => {
            const oldSub = oldSubs.find((s) => s.id === sub.id);

            if (!oldSub) {
                newSubcategories.push({
                    categoryId: Number(cat.id),
                    name: sub.label,
                    position: index,
                    priorityId: sub.priority ?? null,
                    requestText: sub.textInput ?? false,
                    supplierId: sub.provider ?? null,
                    ...(sub.children.length > 0 && {
                        drop_downs_links: sub.children.flatMap((ch) =>
                            formatDropDownLinks(ch, sub)
                        ),
                    }),
                });
            }

            else if (oldSub) {
                const isChanged = deepCompareItems(oldSub, sub, index);
                if (isChanged) {
                    editSubcategories.push({
                        id: Number(sub.id),
                        name: sub.label,
                        position: index,
                        priorityId: sub.priority ?? null,
                        requestText: sub.textInput ?? false,
                        supplierId: sub.provider ?? null,
                        ...(sub.children.length > 0 && {
                            drop_downs_links: sub.children.flatMap((ch) =>
                                formatDropDownLinks(ch, sub)
                            ),
                        }),
                    });
                }
            }
        });

        oldSubs.forEach((oldSub) => {
            const stillExists = newSubs.some(
                (s) => String(s.id) === String(oldSub.id)
            );
            if (!stillExists) subcategoriesToDelete.push(oldSub.id);
        });
    });

    normalizeditemsFromEndpoint.forEach((oldCat) => {
        const stillExists = items.some((c) => String(c.id) === String(oldCat.id));
        if (!stillExists) categoriesToDelete.push(Number(oldCat.id));
    });


    return {
        name: catalogName,
        newCategories,
        newSubcategories,
        categoriesToDelete,
        subcategoriesToDelete,
        editCategories,
        editSubcategories,
    };
};

export { createCatalogBody, updateCatalogBody }